import React from 'react';
import { View } from 'react-native';

import LogoIcon from '~/assets/svgs/LogoIcon.svg';
import Text from '~/components/Text';
import Container from '../Container';

const Header: React.FC = () => {
  return (
    <Container className="pt-6 sm:flex-row sm:items-center">
      <View className="mx-auto sm:mx-0 sm:mr-4">
        <LogoIcon />
      </View>
      <View className="items-center justify-center sm:items-start">
        <Text className="text-xl mt-4 sm:mt-0 font-medium">
          Bem-vinda ao{' '}
          <Text className="text-primary-600 text-xl font-medium">
            Marisa +Serviços
          </Text>
        </Text>
        <Text className="text-center mt-4 text-gray-400 sm:text-left sm:mt-4 text-sm mb-6">
          A mais nova plataforma de cartões, serviços e assistências da Marisa.
          Aproveite e conte conosco!
        </Text>
      </View>

      <View className="h-[1px] bg-gray-200 mb-6" />
    </Container>
  );
};

export default Header;
